import { permissions, UserWithRole } from '@utilities-one/api-sdk';

import { hasPermission } from '@/entities/user/utils/access';

/**
 * Users who can approve splicing invoices are not restricted by OPM/director/VP project scoping
 * on invoice lists and detail loads (same visibility as viewAll for that dimension only).
 */
export const canBypassCompanyInvoiceRoleScopeForSplicing = (user: UserWithRole): boolean =>
  hasPermission(user, permissions.companyInvoices.approve.splicingDirectorApprove) ||
  hasPermission(user, permissions.companyInvoices.approve.splicingVpApprove);
